import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { List } from 'react-toolbox/lib/list'
import { nest, lifecycle, mapProps, withState, withHandlers, compose } from 'recompose'
import { Flex } from 'reflexbox'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import hideOnAnyRoles from 'containers/Role/Hide/AllGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'

import Card from './Card'
import Actions from './Actions'
import UserInput from './UserInput'
import Divider from 'components/fulcrum/divider/Divider'
import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'
import Input from 'components/fulcrum/input/Input'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'

import {
  fetchEmployeeListWithImages as fetchEmployeeList,
} from 'containers/User/actions'
import {
  employeeListWithImageValues as employeeListSelector,
  isLoadingEmployeeList,
} from 'containers/User/selectors'
import {
  TEAM_ENUM,
  MODULE_NAME,
} from './constants'
import {
  fetchSupportTeam,
  postSupportTeam,
  updateSupportTeamChange,
} from './actions'
import {
  aeSelector,
  aemSelector,
  cpmSelector,
  faeSelector,
  aedSelector,
  paeSelector,
  amSelector,
  pmSelector,
  spmSelector,
  cpdSelector,
  observerSelector
} from './selectors'

import supportTeamSagas from './sagas'
import AERegion from '../AERegion/index'
import { postAeRegion, fetchAeRegionSelection } from '../AERegion/actions'

const mapStateToProps = (state) => {
  return {
    aeSource: aeSelector(state),
    cpmSource: cpmSelector(state),
    aemSource: aemSelector(state),
    faeSource: faeSelector(state),
    aedSource: aedSelector(state),
    paeSource: paeSelector(state),
    amSource: amSelector(state),
    pmSource: pmSelector(state),
    spmSource: spmSelector(state),
    cpdSource: cpdSelector(state),
    observerSource: observerSelector(state),
    employeeList: employeeListSelector(state),
    isLoading: isLoadingEmployeeList(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  const addRoleToUsers = role => R.map(user => ({ role, ...user }))

  return {
    fetchSupportTeam: (id) => dispatch(fetchSupportTeam(id)),
    fetchEmployeeList: (query) => dispatch(fetchEmployeeList(query)),
    onAeChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.ACCOUNT_APPLICATIONS_ENGINEER)(team),
      TEAM_ENUM.ACCOUNT_APPLICATIONS_ENGINEER
    )),
    onCpmChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.CUSTOMER_PROGRAM_MANAGER)(team),
      TEAM_ENUM.CUSTOMER_PROGRAM_MANAGER
    )),
    onAemChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.APPLICATIONS_ENGINEERING_MANAGER)(team),
      TEAM_ENUM.APPLICATIONS_ENGINEERING_MANAGER
    )),
    onFaeChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.FIELD_APPLICATIONS_ENGINEER)(team),
      TEAM_ENUM.FIELD_APPLICATIONS_ENGINEER
    )),
    onAedChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.APPLICATIONS_ENGINEERING_DIRECTOR)(team),
      TEAM_ENUM.APPLICATIONS_ENGINEERING_DIRECTOR
    )),
    onPaeChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.PRODUCT_APPLICATIONS_ENGINEER)(team),
      TEAM_ENUM.PRODUCT_APPLICATIONS_ENGINEER
    )),
    onAmChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.ACCOUNT_MANAGER)(team),
      TEAM_ENUM.ACCOUNT_MANAGER
    )),
    onPmChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.PRODUCT_MANAGER)(team),
      TEAM_ENUM.PRODUCT_MANAGER
    )),
    onSpmChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER)(team),
      TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER
    )),
    onCpdChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.CUSTOMER_PROGRAM_DIRECTOR)(team),
      TEAM_ENUM.CUSTOMER_PROGRAM_DIRECTOR
    )),
    onObserverChange: (team) => dispatch(updateSupportTeamChange(
      addRoleToUsers(TEAM_ENUM.OBSERVER)(team),
      TEAM_ENUM.OBSERVER
    )),
    onSave: (id) => {
      dispatch(postAeRegion(id))
      dispatch(postSupportTeam(id))
    },
    fetchAeRegionSelection: () => dispatch(fetchAeRegionSelection())
  }
}

const SectionCard = (props) => {
  const {
    id,
    aeSource,
    aemSource,
    cpmSource,
    faeSource,
    aedSource,
    paeSource,
    amSource,
    pmSource,
    spmSource,
    cpdSource,
    observerSource,
    employeeList,
    fetchEmployeeList,
    onAeChange,
    onCpmChange,
    onAemChange,
    onFaeChange,
    onAedChange,
    onPaeChange,
    onAmChange,
    onPmChange,
    onSpmChange,
    onCpdChange,
    onObserverChange,
    isLoading,
    fetchAeRegionSelection,
    ...rest
  } = props

  

  return (
    <Card>
      <CardHeader title='Support Team'>
        <Actions
          {...props}
        />
      </CardHeader>
      <Collapse collapse={props.collapse}>
        <Divider/>
        <AERegion id={id} edit={props.edit}/>
        <UserInput
          label={TEAM_ENUM.CUSTOMER_PROGRAM_MANAGER}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onCpmChange}
          value={cpmSource}
          isLoading={isLoading}
          edit={props.edit}
        />
        <UserInput
          label={TEAM_ENUM.APPLICATIONS_ENGINEERING_MANAGER}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onAemChange}
          value={aemSource}
          isLoading={isLoading}
          edit={props.edit}
        />
        <UserInput
          label={TEAM_ENUM.ACCOUNT_APPLICATIONS_ENGINEER}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onAeChange}
          value={aeSource}
          isLoading={isLoading}
          edit={props.edit}
        />
        <UserInput
          label={TEAM_ENUM.FIELD_APPLICATIONS_ENGINEER}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onFaeChange}
          value={faeSource}
          isLoading={isLoading}
          edit={props.edit}
        />
        <UserInput
          label={TEAM_ENUM.APPLICATIONS_ENGINEERING_DIRECTOR}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onAedChange}
          value={aedSource}
          isLoading={isLoading}
          edit={props.edit}
        />
        <UserInput
          label={TEAM_ENUM.PRODUCT_APPLICATIONS_ENGINEER}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onPaeChange}
          value={paeSource}
          isLoading={isLoading}
          edit={props.edit}
        />
        {
          /*<UserInput
            label={TEAM_ENUM.ACCOUNT_MANAGER}
            options={employeeList}
            onInputChange={fetchEmployeeList}
            onChange={onAmChange}
            value={amSource}
            isLoading={isLoading}
            edit={props.edit}
          />*/
        }
        <UserInput
          label={TEAM_ENUM.PRODUCT_MANAGER}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onPmChange}
          value={pmSource}
          isLoading={isLoading}
          edit={props.edit}
        />        
        <UserInput
          label={TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onSpmChange}
          value={spmSource}
          isLoading={isLoading}
          edit={props.edit}
        />
        <UserInput
          label={TEAM_ENUM.CUSTOMER_PROGRAM_DIRECTOR}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onCpdChange}
          value={cpdSource}
          isLoading={isLoading}
          edit={props.edit}
        />
        <UserInput
          label={TEAM_ENUM.OBSERVER}
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onObserverChange}
          value={observerSource}
          isLoading={isLoading}
          edit={props.edit}
        />
      </Collapse>
    </Card>
  )
}

const SupportTeamSection = nest(Section, SectionCard)

const withModify = compose(
  withState('edit', 'toggleEdit', false),
  withHandlers({
    toggleEdit: ({ toggleEdit }) => () => toggleEdit(e => !e)
  })
)

const withLifecycle = lifecycle({
  componentDidMount() {
    const { id, fetchSupportTeam } = this.props
    fetchSupportTeam(id)
  }
})

const withRoles = compose(
  mapProps(
    (props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.CLIENT_ACCESS,
      ]
    })
  ),
  hideOnAnyRoles,
)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: supportTeamSagas})
export default compose(
  withRoles,
  withConnect,
  withSagas,
  withCollapse,
  withModify,
  withLifecycle
)(SupportTeamSection)
